import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-runbook-resources';


@Injectable({
  providedIn: 'root'
})
export class RunbookService {

  constructor(private fabricService: FabricService) {}

  postRunbook(obj): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_instances_id_runbooks', obj);
  }

  putRunbook(obj): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_runbooks_runbookid_redeploy', obj);
  }

  patchRunbook(obj): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'patch_mgmt_instances_id_runbooks_runbookid_inputs', obj);
  }

  getRunbook(id: String, status?: String): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_runbooks', {id, status});
  }

  getRunbookById(id: any, runbookId: any): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_runbooks_runbookid', {id, runbookId});
  }

  deleteRunbook(id, runbookId): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_mgmt_instances_id_runbooks_runbookid', {id, runbookId});
  }

  patchRunbookVersion(obj): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'patch_mgmt_instances_id_runbooks_runbookname_version', obj);
  }

}

